import { useEppo } from '@/composables/eppo/index.js'
import { FEATURE_FLAGS } from '@/lib/consts.js'

const microFrontendRootUrl = 'inventory/products'

const isMicroFrontendInventoryEnabled = () => !!useEppo()?.ff(FEATURE_FLAGS.Feature_MicroFrontendInventory)

export default [
  {
    path: ':path(products.*)?',
    name: 'inventory.products',
    beforeEnter: (to, from, next) => {
      // :path(products.*)? path doesn't add products to url so it needs to be added manually
      // this change in path is needed to handle url in more elastic way for Inventory micro-frontend
      if (!to.path.includes(microFrontendRootUrl)) {
        return next({
          path: to.path + (to.path.endsWith('/') ? '' : '/') + 'products',
          query: to.query,
          hash: to.hash,
        })
      }

      next()
    },
    component: () => {
      return isMicroFrontendInventoryEnabled() ? import('@/views/business/inventory/products/iframe-service.vue') : import('@/views/business/inventory/products/list.vue')
    },
  },
  {
    path: 'products/:productId',
    name: 'inventory.product-card',
    beforeEnter: (to, from, next) => {
      // if micro-frontend inventory is enabled, user is redirected to default /inventory/products path
      return isMicroFrontendInventoryEnabled() ? next({ path: to.path.split(microFrontendRootUrl)[0] + microFrontendRootUrl }) : next()
    },
    component: () => import('@/views/business/inventory/products/details/index.vue'),
    meta: {
      defaultSubroute: { name: 'inventory.product-card.details' },
      hideTabs: true,
    },
    children: [
      {
        path: 'details',
        name: 'inventory.product-card.details',
        component: () => import('@/views/business/inventory/products/details/details.vue'),
        meta: {
          hideTabs: true,
        },
      },
      {
        path: 'photos',
        name: 'inventory.product-card.photos',
        component: () => import('@/views/business/inventory/products/details/photos.vue'),
        meta: {
          hideTabs: true,
        },
      },
      {
        path: 'description',
        name: 'inventory.product-card.description',
        component: () => import('@/views/business/inventory/products/details/description.vue'),
        meta: {
          hideTabs: true,
        },
      },
      {
        path: 'location',
        name: 'inventory.product-card.location',
        component: () => import('@/views/business/inventory/products/details/location.vue'),
        meta: {
          hideTabs: true,
        },
      },
      {
        path: 'suppliers',
        name: 'inventory.product-card.suppliers',
        component: () => import('@/views/business/inventory/products/details/suppliers.vue'),
        meta: {
          hideTabs: true,
        },
      },
      {
        path: 'history',
        name: 'inventory.product-card.history',
        component: () => import('@/views/business/inventory/products/details/history.vue'),
        meta: {
          hideTabs: true,
        },
      },
    ],
  },
]
